module.exports = __webpack_public_path__ + "static/media/Great Baggi.4bebe51f.png";


//////////////////
// WEBPACK FOOTER
// ./src/eggs/images/Great Baggi.png
// module id = 113
// module chunks = 0